import { Component, OnInit } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-status-overzicht-select',
  templateUrl: './status-overzicht-select.component.html',
  styleUrls: ['./status-overzicht-select.component.less']
})
export class StatusOverzichtSelectComponent implements OnInit {

  constructor(private relatieService : RelatiesService) {

  }


  ngOnInit(): void {
  }

  


  KlantAfkortingInp: string = "";
  objectnrInp :string = "" ;

  KlantAfkorting: string = "";
  objectnr :string = "" ;

  doFilter() {
    this.KlantAfkorting = this.KlantAfkortingInp;
    this.objectnr = this.objectnrInp;
  }

  relatieChange(event:any) {
    this.relatieService.getRelatie(event).subscribe(data => {
      this.KlantAfkortingInp = data.Afkorting;
    })
  }
}
